import React from "react";

import "./HeroSection.scss";

function ContactInfo(props) {
  return (
    <div>
        <div className="gdlr-core-pbf-wrapper ">
            <div className="gdlr-core-pbf-wrapper-content gdlr-core-js ">
                <div className="gdlr-core-pbf-wrapper-container clearfix gdlr-core-container">
                    <div className="contact_ribbon">
                        If you're calling from abroad and want to make free calls to us, feel free to use our phone number. We are active on WhatsApp & Viber. 
                    </div>
                </div>
                <div className="gdlr-core-pbf-wrapper-container clearfix gdlr-core-container">
                    <div className="gdlr-core-pbf-column gdlr-core-column-20 gdlr-core-column-first">
                        <div className="gdlr-core-pbf-column-content-margin gdlr-core-js " style={{padding:'50px 20px 0px 20px'}} >
                            <div className="gdlr-core-pbf-column-content clearfix gdlr-core-js ">
                                <div className="gdlr-core-pbf-element">
                                    <div className="gdlr-core-icon-item gdlr-core-item-pdlr gdlr-core-item-pdb gdlr-core-left-align" style={{paddingBottom:'55px'}} ><i className=" gdlr-core-icon-item-icon fa fa-phone" style={{fontSize:'40px', color:'#454545', minWidth:'40px', minHeight:'40px'}}></i></div>
                                </div>
                                <div className="gdlr-core-pbf-element">
                                    <div className="gdlr-core-title-item gdlr-core-item-pdb clearfix  gdlr-core-left-align gdlr-core-title-item-caption-top gdlr-core-item-pdlr" style={{paddingBottom:'25px'}}>
                                        <div className="gdlr-core-title-item-title-wrap">
                                            <h3 className="gdlr-core-title-item-title gdlr-core-skin-title" style={{fontSize:'24px', letterSpacing:'0px', textTransform:'none'}} >Phone<span className="gdlr-core-title-item-title-divider gdlr-core-skin-divider" ></span></h3></div>
                                    </div>
                                </div>
                                <div className="gdlr-core-pbf-element">
                                    <div className="gdlr-core-text-box-item gdlr-core-item-pdlr gdlr-core-item-pdb gdlr-core-left-align" style={{paddingBottom:'0px'}} >
                                        <div className="gdlr-core-text-box-item-content" style={{fontSize:'16px'}} >
                                            <p>You can call us anytime, we will be happy to help!</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="gdlr-core-pbf-element">
                                    <div className="gdlr-core-text-box-item gdlr-core-item-pdlr gdlr-core-item-pdb gdlr-core-left-align">
                                        <div className="gdlr-core-text-box-item-content" style={{fontSize:'16px'}}>
                                            <p><a href="tel:4152837321">(415) 283 7321</a></p>
											<small style={{color:'#232323'}}>Se habla español</small><br/>
											<small style={{color:'#232323'}}>On parle français</small>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="gdlr-core-pbf-column gdlr-core-column-20">
                        <div className="gdlr-core-pbf-column-content-margin gdlr-core-js " style={{padding:'50px 20px 0px 20px'}}>
                            <div className="gdlr-core-pbf-column-content clearfix gdlr-core-js " >
                                <div className="gdlr-core-pbf-element">
                                    <div className="gdlr-core-icon-item gdlr-core-item-pdlr gdlr-core-item-pdb gdlr-core-left-align" style={{paddingBottom:'55px'}}><i className=" gdlr-core-icon-item-icon fa fa-envelope-o" style={{fontSize:'40px', color:'#454545', minWidth:'40px', minHeight:'40px'}}></i></div>
                                </div>
                                <div className="gdlr-core-pbf-element">
                                    <div className="gdlr-core-title-item gdlr-core-item-pdb clearfix  gdlr-core-left-align gdlr-core-title-item-caption-top gdlr-core-item-pdlr" style={{paddingBottom:'25px'}}>
                                        <div className="gdlr-core-title-item-title-wrap">
                                            <h3 className="gdlr-core-title-item-title gdlr-core-skin-title" style={{fontSize:'24px', letterSpacing:'0px', textTransform:'none'}}>Email<span className="gdlr-core-title-item-title-divider gdlr-core-skin-divider" ></span></h3></div>
                                    </div>
                                </div>
                                <div className="gdlr-core-pbf-element">
                                    <div className="gdlr-core-text-box-item gdlr-core-item-pdlr gdlr-core-item-pdb gdlr-core-left-align" style={{paddingBottom:'0px'}}>
                                        <div className="gdlr-core-text-box-item-content" style={{fontSize:'16px'}}>
                                            <p>Email us if you have any questions/suggestions.</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="gdlr-core-pbf-element">
                                    <div className="gdlr-core-text-box-item gdlr-core-item-pdlr gdlr-core-item-pdb gdlr-core-left-align">
                                        <div className="gdlr-core-text-box-item-content" style={{fontSize:'16px'}}>
                                            <p><a href="mailto:alcatraztourstickets@gmail.com">alcatraztourstickets@gmail.com</a></p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="gdlr-core-pbf-column gdlr-core-column-20">
                        <div className="gdlr-core-pbf-column-content-margin gdlr-core-js " style={{padding:'50px 20px 0px 20px'}}>
                            <div className="gdlr-core-pbf-column-content clearfix gdlr-core-js " >
                                <div className="gdlr-core-pbf-element">
                                    <div className="gdlr-core-icon-item gdlr-core-item-pdlr gdlr-core-item-pdb gdlr-core-left-align" style={{paddingBottom:'55px'}}><i className=" gdlr-core-icon-item-icon fa fa-location-arrow" style={{fontSize:'40px', color:'#454545', minWidth:'40px', minHeight:'40px'}}></i></div>
                                </div>
                                <div className="gdlr-core-pbf-element">
                                    <div className="gdlr-core-title-item gdlr-core-item-pdb clearfix  gdlr-core-left-align gdlr-core-title-item-caption-top gdlr-core-item-pdlr" style={{paddingBottom:'25px'}}>
                                        <div className="gdlr-core-title-item-title-wrap">
                                            <h3 className="gdlr-core-title-item-title gdlr-core-skin-title" style={{fontSize:'24px', letterSpacing:'0px', textTransform:'none'}}>Location<span className="gdlr-core-title-item-title-divider gdlr-core-skin-divider" ></span></h3></div>
                                    </div>
                                </div>
                                <div className="gdlr-core-pbf-element">
                                    <div className="gdlr-core-text-box-item gdlr-core-item-pdlr gdlr-core-item-pdb gdlr-core-left-align" style={{paddingBottom:'0px'}}>
                                        <div className="gdlr-core-text-box-item-content" style={{fontSize:'16px'}}>
                                            <p>2840 Jones St, San Francisco, <br/>CA 94133</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="gdlr-core-pbf-element">
                                    <div className="gdlr-core-text-box-item gdlr-core-item-pdlr gdlr-core-item-pdb gdlr-core-left-align">
                                        <div className="gdlr-core-text-box-item-content" style={{fontSize:'16px'}}>
                                            <p><a target="_blank" href="https://goo.gl/maps/XCwaQmoW6tottBX96">View On Google Map</a></p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
  );
}

export default ContactInfo;
